<template>
    <div class="pa-5">
        <v-dialog :value="imageFileDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ active_img.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                        <v-btn icon @click="downloadFile(active_img.id)">
                            <v-icon color="white">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn dark icon @click="closeDialog">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                    <v-img :src="active_img.picture_path"></v-img>
                </v-container>
            </v-card>
        </v-dialog>
        <v-row
            justify="space-between"
            no-gutters
            v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.UPLOAD)"
        >
            <v-col cols="10">
                <v-file-input :label="t('Upload files')" :value="files" multiple @change="updateFiles($event)" />
            </v-col>
            <v-col class="text-end" cols="2">
                <v-btn :disabled="files.length <= 0" class="mt-3 ml-3 success" @click="submitUpload"
                    >{{ "Upload" | t }}
                </v-btn>
            </v-col>
        </v-row>
        <v-divider />
        <v-list>
            <v-list-item
                v-for="file in activeExportInvoice.invoice_files_data"
                :key="file.id"
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-avatar v-if="file.is_picture" @click="openImageDialog(file)">
                    <v-img :src="file.picture_path" />
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="subtitle-1" v-text="file.name" />
                    <v-list-item-subtitle v-text="file.date" />
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn icon @click="downloadFile(file.id)">
                            <v-icon color="blue lighen-1">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            @click="removeFile(file.id)"
                            v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.UPLOAD)"
                        >
                            <v-icon color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item
                v-if="
                    activeExportInvoice &&
                        activeExportInvoice.invoice_files_data &&
                        activeExportInvoice.invoice_files_data.length <= 0
                "
            >
                <v-list-item-content>
                    <v-list-item-title>{{ "No files found" | t }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Store from "@/store";
import settings from "@/settings";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "file-tab",
    data() {
        return { active_img: [] };
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice", "files", "imageFileDialog"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        updateFiles(e) {
            Store.commit("ExportSaleInvoiceStore/setFiles", { value: e });
        },
        submitUpload() {
            Store.dispatch("ExportSaleInvoiceStore/submitFileUpdate", {
                invoice: this.activeExportInvoice,
                files: this.files
            });
        },
        removeFile(id) {
            if (confirm(this.t("Are you sure you want to delete this file?"))) {
                Store.dispatch("ExportSaleInvoiceStore/removeFile", {
                    file_id: id,
                    invoice_id: this.activeExportInvoice.id
                });
            }
        },
        downloadFile(id) {
            let params = "?act=download_file";
            params += "&file_id=" + id;
            window.location.href = settings.api_url + "/file" + params;
        },
        openImageDialog(file) {
            this.active_img = file;
            Store.commit("ExportSaleInvoiceStore/setImageFileDialog", true);
        },
        closeDialog() {
            this.active_img = [];
            Store.commit("ExportSaleInvoiceStore/setImageFileDialog", false);
        }
    }
};
</script>

<style scoped></style>
